import { styled } from '@material-ui/core';
import { colors, div } from '../common';
import * as React from 'react';
import { Tabs } from '@material-ui/core';
var TransparentTabsContext = React.createContext(null);
export var TabsDivider = styled('div')({
    height: 70,
    width: 1,
    backgroundColor: 'rgba(255,255,255,0.25)',
});
export var TransparentTabs = styled(function (_a) {
    var $value = _a.$value, children = _a.children, className = _a.className;
    return (React.createElement(TransparentTabsContext.Provider, { value: $value },
        React.createElement("div", { className: className }, children)));
})({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
});
export var TransparentTab = styled(function (_a) {
    var value = _a.value, _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children, disabled = _a.disabled;
    var $value = React.useContext(TransparentTabsContext);
    return (React.createElement("div", { className: className + ($value.value === value ? ' selected' : ''), onClick: function () {
            disabled || $value.set(value);
        } }, children));
})({
    margin: 4,
    padding: 8,
    borderRadius: 3,
    cursor: 'pointer',
    '&.selected': {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
    }
});
export var LinearProgress = styled(function (_a) {
    var value = _a.value, max = _a.max, color = _a.color, className = _a.className;
    return React.createElement("div", { className: className },
        React.createElement("div", { className: "progress" }));
})({
    width: "100%",
    borderRadius: 5,
    height: 5,
    backgroundColor: 'rgba(1,1,1,0.1)',
    "& .progress": {
        height: '100%',
        backgroundColor: function (x) { return colors[x.color]; },
        width: function (x) { return x.max ? String(x.value / x.max * 100) + '%' : 0; }
    }
});
export var PageTab = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, disabled = _a.disabled, value = _a.value, label = _a.label, children = _a.children;
    return React.createElement(TransparentTab, { value: value, disabled: disabled },
        React.createElement(PageTabRoot, { disabled: disabled },
            React.createElement("div", { className: "title" }, title),
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "main-info" }, label),
                React.createElement("div", { className: "subtitle" }, subtitle)),
            children));
};
var PageTabRoot = div({
    display: "flex",
    flexDirection: "column",
    color: function (props) { return props.disabled ? "#A0A0A0" : '#FFF'; },
    fontFamily: 'Montserrat',
    '& .main-info': {
        flex: "1 auto",
        fontSize: 22,
        fontWeight: 300,
    },
    '& .container': {
        display: "flex",
        padding: 0,
        flexDirection: "row",
        alignItems: 'baseline',
    },
    '& .title': {
        fontSize: 12,
        fontWeight: 600,
        textTransform: 'uppercase'
    },
    '& .subtitle': {
        fontSize: 12,
        fontWeight: 500,
        marginLeft: 12
    }
});
export var NavigationTabs = styled(function (_a) {
    var className = _a.className, $value = _a.$value, children = _a.children;
    return (React.createElement("div", { className: className },
        React.createElement(Tabs, { value: $value.value, onChange: function (_, x) {
                $value.set(x);
            } }, children)));
})({
    backgroundColor: "#052C4C",
    display: "flex",
    "& .MuiTab-textColorInherit": {
        color: "white"
    }
});
export var Triangle = div({
    width: 16,
    position: "absolute",
    height: 16,
    backgroundColor: "#052C4C",
    top: 50,
    left: function (props) { return props.left; },
    transform: "rotate(45deg)"
});
//# sourceMappingURL=page-tabs.js.map